// extracted by mini-css-extract-plugin
export default {"languageSelect":"LanguageSelect_languageSelect__P6uhS"};